import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useDispatch } from 'react-redux';
import { SubNavigationClicked } from '../../../../components/HeaderNew/actionTypes.js';
import { MaskedLink } from '../../../../components/internal/MaskedLink/index.js';
import { Container } from '../../../../components/Menu/components/SubItem/components/Container.js';
export const SubItem = ({
  item
}) => {
  const {
    masked,
    caption,
    path,
    target
  } = item;
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch({
      type: SubNavigationClicked,
      payload: {
        text: caption
      }
    });
  };
  return masked ? _jsx(MaskedLink, {
    href: path,
    target: target,
    children: _jsx(Container, {
      as: "span",
      onClick: handleClick,
      children: caption
    })
  }) : _jsx(Container, {
    href: path,
    target: target,
    onClick: handleClick,
    children: caption
  });
};